import { BaseSiteEffects } from './base-site.effect';
import { CountryEffects } from './country.effect';
import { CurrenciesEffects } from './currencies.effect';
import { LanguagesEffects } from './languages.effect';

export const effects: any[] = [
  LanguagesEffects,
  CurrenciesEffects,
  BaseSiteEffects,
  CountryEffects
];

export * from './base-site.effect';
export * from './country.effect';
export * from './currencies.effect';
export * from './languages.effect';

